import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Grid, Card, CardContent, CardMedia, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import ekstraklasaImage from '../assets/images/ekstraklasa.jpg';
import liga1Image from '../assets/images/1liga.jpg';
import liga2Image from '../assets/images/2liga.jpg';
import lowerLeaguesImage from '../assets/images/niskie.jpg';

// Kafelki szybkiego dostępu
const quickAccessTiles = [
  { title: 'Ekstraklasa', description: 'Sprawdź nasze symulacje!', link: '/liga/14', image: ekstraklasaImage },
  { title: '1. Liga', description: 'Sprawdź nasze symulacje!', link: '/liga/15', image: liga1Image },
  { title: '2. Liga', description: 'Sprawdź nasze symulacje!', link: '/liga/16', image: liga2Image },
  { title: 'Niższe ligi', description: 'Wybierz z górnego menu...', image: lowerLeaguesImage },
];

// Uniwersalny obrazek dla wszystkich artykułów
const defaultArticleImage = "https://images.unsplash.com/photo-1512777576244-b8466820fd0d?q=80&w=2072&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

const HomePage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    axios.get(`${process.env.REACT_APP_API_URL}/api/articles`)
      .then(response => {
        console.log('Pobrane artykuły na stronie głównej:', response.data);
        // Bierzemy maksymalnie 3 najnowsze artykuły
        const latestArticles = (response.data || []).slice(0, 3);
        setArticles(latestArticles);
        setLoading(false);
      })
      .catch(error => {
        console.error('Błąd podczas pobierania artykułów:', error);
        setError('Nie udało się pobrać artykułów.');
        setLoading(false);
      });
  }, []);

  return (
    <Box>
      {/* Sekcja powitalna */}
      <Box sx={{ textAlign: 'center', padding: { xs: '20px', md: '40px' } }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          SymuLiga.pl – Twoje centrum predykcji piłkarskich!
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, maxWidth: '600px', margin: '0 auto' }}>
          Zaawansowana symulacja wyników polskich drużyn: przewiduj szanse, projektuj scenariusze i monitoruj rankingi ELO. Chcesz współpracować lub masz pytania? Pisz na kontakt@symuliga.pl.
        </Typography>
      </Box>

      <Box sx={{ padding: { xs: '20px', md: '40px' } }}>
  <Grid container spacing={3} justifyContent="center">
    {quickAccessTiles.map(tile => (
      <Grid item xs={12} sm={6} md={3} key={tile.title}>
        {tile.link ? (
          <Link to={tile.link} style={{ textDecoration: 'none' }}>
            <Card sx={{ cursor: 'pointer' }}>
              <CardMedia
				  component="img"
				  height="140"
				  image={tile.image}
				  alt={tile.title}
				  sx={{ objectFit: 'cover' }} // Dopasowanie obrazka do kafelka
				/>
              <CardContent>
                <Typography variant="h6">{tile.title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {tile.description}
                </Typography>
              </CardContent>
            </Card>
          </Link>
        ) : (
          <Card>
            <CardMedia
			  component="img"
			  height="140"
			  image={tile.image}
			  alt={tile.title}
			  sx={{ objectFit: 'cover' }} // Dopasowanie obrazka do kafelka
			/>
            <CardContent>
              <Typography variant="h6">{tile.title}</Typography>
              <Typography variant="body2" color="text.secondary">
                {tile.description}
              </Typography>
            </CardContent>
          </Card>
        )}
      </Grid>
    ))}
  </Grid>
</Box>

      {/* Najnowsze artykuły */}
      <Box sx={{ padding: { xs: '20px', md: '40px' } }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          Najnowsze artykuły
        </Typography>

        {loading ? (
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            Ładowanie artykułów...
          </Typography>
        ) : error ? (
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            {error}
          </Typography>
        ) : articles.length === 0 ? (
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            Brak artykułów do wyświetlenia.
          </Typography>
        ) : (
          <Grid container spacing={3} justifyContent="center">
            {articles.map(article => (
              <Grid item xs={12} sm={6} md={4} key={article.id}>
                <Link to={`/blog/${article.slug}`} style={{ textDecoration: 'none' }}>
                  <Card sx={{ cursor: 'pointer' }}>
                    <CardMedia
                      component="img"
                      height="140"
                      image={article.image}
                      alt={article.title}
                    />
                    <CardContent>
                      <Typography variant="h6">{article.title}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {article.publishedAt} | Autor: {article.author}
                      </Typography>
                      <Button size="small" sx={{ mt: 1 }}>
                        Czytaj więcej
                      </Button>
                    </CardContent>
                  </Card>
                </Link>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default HomePage;